<template>
  <div
    v-for="(item, index) in messages"
    :key="index"
    class="mb-12"
    v-motion
    :initial="{
      opacity: 0,
      x: item.user == 'homero' && index == messages.length - 1 ? -50 : 0,
    }"
    :enter="enterMotion"
  >
    <div
      id="homero-message"
      v-if="item.user == 'homero'"
      class="w-full flex items-start flex-col space-y-2"
    >
      <p class="font-[800] capitalize text-h-info-500" v-if="item.message">
        {{ item.user }}
      </p>
      <div
        class="bg-h-primary-100 p-4 drop-shadow-lg rounded-md"
        v-if="item.message"
      >
        <p v-html="item.message"></p>

        <p
          v-if="item === messages[messages.length - 1] && action.isGpt"
          class="my-5"
        >
          {{
            $t("labels.generic", {
              pt: "Deseja pesquisar sobre vídeos relacionados no curso?",
              en: "Want to search for related videos in the course?",
            })
          }}
        </p>

        <div class="w-48 flex flex-row space-x-2 mt-4">
          <MessageVoice
            :msg="removeTags(item.message)"
            :showIconsName="false"
            :autoPlay="autoPlay"
          />
        </div>
      </div>
      <div
        id="keywords"
        v-if="item === messages[messages.length - 1] && action.isGpt"
        class="pt-5 flex flex-col gap-5"
      >
        <Button
          label="Sim, eu quero!"
          class="btn-outline p-button-sm w-fit h-10"
          @click="onOpenCrawler('')"
        />
      </div>
      <div
        class="p-4 drop-shadow-lg flex flex-col space-y-2 rounded-md"
        v-if="item.options.length > 0"
      >
        <span v-for="(option, i) in item.options" :key="i">
          <Button
            :label="option.name"
            @click="option.action"
            :class="`btn-outline hidden`"
            :disabled="!option.active"
            v-if="option.active"
          />
        </span>
      </div>
    </div>
    <div
      id="my-messages"
      v-if="item.user == 'me'"
      class="w-full flex items-end flex-col space-y-2"
    >
      <p class="text-h-primary-500 font-[800] capitalize">
        {{
          $t("labels.generic", {
            pt: "Você",
            en: "You",
          })
        }}
      </p>
      <div
        class="msg-box bg-white p-4 drop-shadow-md text-right rounded-md break-words"
      >
        <p v-if="item.type == 'text'" v-html="item.message"></p>
        <section v-if="item.type == 'audio'">
          <audio :id="'audio' + index" :src="item.audio" controls></audio>
        </section>
      </div>
    </div>
  </div>
  <div
    class="msg-box bg-white p-4 drop-shadow-md text-right rounded-md w-[12%] my-5"
    v-if="loaderMsg"
  >
    <img
      src="@/assets/images/typing.gif"
      alt="typing"
      loading="lazy"
      class="w-full"
    />
  </div>
</template>

<script lang="ts">
import { ChatModel } from "@/models/chat.model";
import { MotionEnter, MotionTransition } from "@/models/motion.model";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "chatMessages",
  emits: ["onOpenCrawler"],
  props: {
    messages: {
      type: Array as PropType<ChatModel[]>,
      default: new Array<ChatModel[]>(),
    },
    action: {
      type: Object as PropType<any>,
    },
    loaderMsg: {
      type: Boolean,
      default: false,
    },
    autoPlay: {
      type: Boolean,
    },
  },
  data() {
    return {
      enterMotion:  new MotionEnter(1,0,0, new MotionTransition(250)),
    };
  },
  methods: {
    onOpenCrawler(keyword: string): void {
      this.$emit("onOpenCrawler", keyword);
    },
    removeTags(str: string): string {
      return str.replace(/(<([^>]+)>)/gi, "");
    },
  },
});
</script>
